/**
 * Version del bundle que esta corriendo en este navegador.
 *
 * La clave es nueva a proposito: antes se guardaba aqui un timestamp (un numero
 * gigante) y comparar "2.5.13" contra ese numero por partes noeria comparable.
 * Con clave nueva, quien ya tenga la vieja se trata como primer arranque y
 * adopta la version actual sin avisar, que es lo correcto.
 */
export const ESTABLISHMENT_APP_VERSION_KEY = '_Slenv__appVersion'

// Version que el usuario rechazo con "Ahora no". Se guarda aparte de la anterior
// para no insisitir por esa misma version, pero volver a avisar si aparece una mas
// nueva.
export const ESTABLISHMENT_APP_VERSION_DISMISSED_KEY = '_Slenv__appVersionDismissed'

export const ESTABLISHMENT_SECTOR = {
  COMMERCIAL: 1,
  AUTOMOTIVE: 2,
  HOTEL: 3,
  LOAN: 4,
}

export const ESTABLISHMENT_SECTORS = [
  {
    value: ESTABLISHMENT_SECTOR.COMMERCIAL,
    label: "Comercial"
  },
  {
    value: ESTABLISHMENT_SECTOR.AUTOMOTIVE,
    label: "Automotriz"
  },
  // {
  //   value: ESTABLISHMENT_SECTOR.HOTEL,
  //   label: "Hotelero"
  // },
  {
    value: ESTABLISHMENT_SECTOR.LOAN,
    label: "Cobranzas"
  }
]

export const ESTABLISHMENT_TREASURY_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

export const ESTABLISHMENT_TREASURY_STATUS_OPTIONS = [
  {
    value: ESTABLISHMENT_TREASURY_STATUS.ACTIVE,
    label: "Activa"
  },
  {
    value: ESTABLISHMENT_TREASURY_STATUS.INACTIVE,
    label: "Inactiva"
  }
]
